import "./matchViewHeader.css"

import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import {Button, Modal, Tooltip} from "@mui/material";

import {useTranslate, useAction, useDownloadCSV} from "../../../../hooks";
import {MIN_PLAYERS_COUNT, MAX_PLAYERS_COUNT} from "../../../../constants"
import {formatTime} from "../../../../helpers"

import {AddPlayerForm} from "../../../../containers"

const MatchViewHeader = () => {
    const {isStart, isFinish, isPause, name, time, date} = useSelector(state => state.match);
    const {players} = useSelector(state => state.player);
    const [showModal, setShowModal] = useState(false)

    const dateFormatted = date ? `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}` : ''

    const {
        DATE_MATCH,
        BTN_MATCH_START_TEXT,
        BTN_MATCH_FINISH_TEXT,
        BTN_MATCH_CONTINUE_TEXT,
        BTN_MATCH_STOP_TEXT,
        TIME_LEFT,
        BTN_MATCH_CSV_TEXT,
        FORM_ADD_PLAYER_SUBMIT_TEXT,
        ADD_PLAYER_TOOLTIP
    } = useTranslate();
    const {setStart, setFinish, setPause, addTime} = useAction();
    const downloadCSV = useDownloadCSV();

    const isButtonStartDisabled = players.length < MIN_PLAYERS_COUNT;
    const isButtonAddPlayerDisabled = players.length === MAX_PLAYERS_COUNT

    useEffect(() => {
        let timer = null;
        const tick = 1000;
        if(isPause || isFinish) {
            clearInterval(timer)
        }
        if(!timer && !isPause && isStart) {
            timer = setInterval(() => {
                addTime({time: tick})
            }, tick)
        }
        return () => {
            clearInterval(timer)
        }
    }, [isStart, isFinish, isPause])

    return (
        <>
            <div className="match-view-header">
                <div className="match-view-header-info">
                    <div>
                        {name && <h2>{name}</h2>}
                        {date && <h2>{`${DATE_MATCH}: ${dateFormatted}`}</h2>}
                    </div>
                    {isStart && (
                        <div className="match-view-header-timer">
                            {TIME_LEFT}: <span>{formatTime(time/1000)}</span>
                        </div>
                    )}
                </div>
                <div className="match-view-header-buttons">
                    {!isStart && (
                        <Button
                            color="success"
                            variant="contained"
                            disabled={isButtonStartDisabled}
                            onClick={() => {
                                setStart()
                            }}
                        >
                            {BTN_MATCH_START_TEXT}
                        </Button>
                    )}
                    {isStart && !isFinish && (
                        <Button
                            color={isPause ? "success" : "error"}
                            variant="contained"
                            onClick={() => {
                                setPause({value: !isPause})
                            }}
                        >
                            {isPause ? BTN_MATCH_CONTINUE_TEXT : BTN_MATCH_STOP_TEXT}
                        </Button>
                    )}
                    {isPause && !isFinish && (
                        <Button
                            color="error"
                            variant="contained"
                            onClick={() => {
                                setFinish()
                            }}
                        >
                            {BTN_MATCH_FINISH_TEXT}
                        </Button>
                    )}
                    {isFinish && (
                        <Button
                            color="success"
                            variant="contained"
                            onClick={downloadCSV}
                        >
                            {BTN_MATCH_CSV_TEXT}
                        </Button>
                    )}
                    {!isStart && (
                        <Tooltip title={ADD_PLAYER_TOOLTIP} placement="top-end">
                            <Button
                                disabled={isButtonAddPlayerDisabled}
                                color="success"
                                variant="contained"
                                onClick={() => {
                                    setShowModal(true)
                                }}
                            >
                                {FORM_ADD_PLAYER_SUBMIT_TEXT}
                            </Button>
                        </Tooltip>
                    )}
                </div>
            </div>
            <Modal
                open={showModal}
                onClose={() => {
                    setShowModal(false)
                }}
            >
                <AddPlayerForm hide={() => {
                    setShowModal(false)
                }}/>
            </Modal>
        </>
    )
}

export default MatchViewHeader